import { action, makeObservable, override } from 'mobx';

import { Loadable, Sort, Search } from 'stores';

import { membersFiltersDescriptors } from '../Filters';

class Members extends Loadable<RacerType, FiltersType> {
  declare filters: FiltersType;

  static defaultFilters = {
    limit: 200,
    with: 'wave;class;fields.field;team',
    searchJoin: 'AND',
  };

  distanceId: number = 0;

  sort = new Sort(membersFiltersDescriptors);
  search = new Search(membersFiltersDescriptors);
  extensions = [this.sort, this.search];

  constructor() {
    super();

    makeObservable(this);
    this.filters = Members.defaultFilters;
  }

  @action
  updateCurrentDistance(distanceId: number) {
    this.distanceId = distanceId;
  }

  @override
  clearFilters() {
    super.clearFilters();
    this.filters = Members.defaultFilters;
  }

  findValue(id: number): nil | RacerType {
    return this.values.find((racer) => racer.id === id);
  }

  // READY ORDER FILTER
  @action
  async enableReadyOrder() {
    this.filters['has'] = 'readyOrder';
  }

  @action
  async disableReadyOrder() {
    this.filters['has'] = null;
    delete this.filters['has'];
  }
}

export { Members };
